<app-nav-menu></app-nav-menu>
<div class="outerDiv">

  <div class="main_Div" #mainDiv>

    <div class="paymentHeading">
      Group Title Details
    </div>
    <div class="col-sm-3 d-flex justify-content-evenly" style="column-gap: 10px">
      <div>
        <a class="card-icon" (click)="showDialog()">
          <i class="uil uil-file-plus-alt card_custom-icon"></i>Add Group Title
        </a>
      </div>
    </div>

    <div class="col-12">
      <dx-data-grid #paymentsGrid
        [dataSource]="groupTitleList"
        [showBorders]="true"
        [showRowLines]="true"
        [columnAutoWidth]="true"
        [columnHidingEnabled]="true"
        [allowColumnResizing]="true">

        <dxo-scrolling mode="standard"></dxo-scrolling>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 75, 100]"></dxo-pager>
        <dxo-search-panel [visible]="true"></dxo-search-panel>

        <dxi-column [visible]="false" dataField="groupTitleId" alignment="center" caption="Group Title Id"></dxi-column>
        <dxi-column dataField="groupTitle" alignment="center" caption="Group Title"></dxi-column>
        <dxi-column [visible]="false" dataField="groupImageName" alignment="center" caption="Group Image Name"></dxi-column>
        <dxi-column [visible]="false" dataField="groupImagePath" alignment="center" caption="Group Image Path"></dxi-column>
        <dxi-column dataField="imageFile" alignment="center" caption="Image File" cellTemplate="imageFileTemplate"></dxi-column>
        <dxi-column alignment="center" caption="Action" cellTemplate="actionCellTemplate" type="buttons" [width]="110"></dxi-column>

        <div *dxTemplate="let info of 'imageFileTemplate'">
          <img [src]="'data:image/jpg;base64,' + info.value" alt="Group Image" style="width:100px;height:100px" />
        </div>

        <div *dxTemplate="let response of 'actionCellTemplate'">
          <i class="fas fa-edit-icon" style="cursor: pointer;" (click)="onEditClick(response.data)"></i>

          &nbsp; &nbsp;

          <i class="fas fa-delete-icon" style="cursor: pointer; color: red" (click)="onDeleteClick(response.data)"></i>


        </div>

      </dx-data-grid>
    </div>


    <!--========= ngPrime Add new group title dialogue ==========-->

    @if (visible) {
      <div class="card flex justify-content-center">
        <p-dialog header="Group Title" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
          <form #addGroupTitleForm="ngForm" (ngSubmit)="onSubmit()">
            <span class="p-text-secondary block mb-5">Update required information</span>
            <div class="flex align-items-center gap-3 mx-3 mb-3 ">
              <label for="groupTitle" class="font-semibold w-6rem">Group Title</label>
              <br />
              <input pInputText name="groupTitle" id="groupTitle" [(ngModel)]="obj.groupTitle" class="flex-auto"
                autocomplete="off" />
                <!--<p class="inputErrors" *ngIf="groupTitleSubmitted && !obj.groupTitle">
                Group Title Required!
              </p>-->
              <p style="display:none" class="inputErrors" id="groupTitleMsg"></p>
            </div>
            <div class="flex align-items-center gap-3 mx-3 mb-5">
              <label for="groupImage" class="font-semibold w-6rem">Group Image</label>
              <br />
              <input name="groupImageName" id="groupImageName" class="file-upload-input" type='file'
                accept="image/*" (change)="onFileSelected($event)" #fileInput />
              </div>
              <div class="flex align-items-center gap-3 mx-3 mb-5">
                <img [src]="imageSource" alt="GroupImage" style="height: 100px; width: 100px" />
                <!--<p class="inputErrors" *ngIf="groupTitleSubmitted && !obj.groupImageName">
                Group Image Required!
              </p>-->
              <p style="display: none;" id="groupImageMsg" class="inputErrors"></p>
            </div>
            <div class="flex justify-content-end gap-4 mx-2">
              <button class="btn btn-sm confirmationModelBtn_close" (click)="visible = false">Cancel</button>
              <button class="btn btn-sm confirmationModelBtn_yes" type="submit"> {{obj.groupTitleId > 0 ? 'Update': 'Save'}}
              </button>
              <!--<p-button label="Cancel" severity="secondary" (click)="visible = false"></p-button> -->
              <!--<p-button label="Save" type="submit"></p-button>-->
              <p style="display:none" id="statusMsg"></p>
            </div>
          </form>
        </p-dialog>
      </div>
    }

    <!--========= ngPrime Add new group title dialogue ==========-->


    <!--=========== Confirmation Dialogue ==========-->

    <p-confirmDialog #cd>
      <ng-template pTemplate="headless" let-message>
        <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
          <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
            <i class="pi pi-question text-5xl"></i>
          </div>
          <span class="font-bold text-2xl block mb-2 mt-4">
            {{ message.header }}
          </span>
          <p class="mb-0">{{ message.message }}</p>
          <div class="flex align-items-center gap-2 mt-4">
            <button pButton
              label="Save"
              (click)="cd.accept()"
              class="w-8rem">
            </button>
            <button pButton
              label="Cancel"
              (click)="cd.reject()"
              class="p-button-outlined w-8rem ">
            </button>
          </div>
        </div>
      </ng-template>
    </p-confirmDialog>
    <!--=============== Confirmation Dialogue ===================-->

  </div>

</div>




